/*

usage:
var ads = new FsAds();
ads.renderPageAds();

*/

import BannerAd from './BannerAd';

class Ads extends BannerAd{

    //you can pass selector parent if you dont want to parse the entire page
    constructor(regionEl){

        console.log("TGX Ads start"); 

        super();

        this.adSelector = '.fsAdContainer:not([data-ad-isrendered])';

        this.collectionIds = [];
        this.adElements = [];
        this.elementsForScroll = [];
        this.adConfigs = [];

        this.pageMeta = undefined;
        this.refreshTimer = undefined;
        //if there is a specific container to parse ads. needs to be selector format
        this.regionEl = regionEl || undefined;
        this.randomizeId = false;
        this.slotCount = 0;

        this.posAll = undefined;

        this.renderOnScroll = false;

        this.isLogEnabled = false;
        this.checkLogEnabled();
        
        this.filterAdSelector();
        this.enableBannerPinning();

        this.bottomOffset = 300;

        this.refreshQueue = [];
        
    }

    //starter method
    renderPageAds(siteConfig){

        this.log("Ads - Render New Set");

        //get page config
        var pageMeta = siteConfig || this.getPageMeta();
        this.setSiteMeta(pageMeta);

        //check if on scroll is enabled
        if(this.renderOnScroll){
            this.adElements = this.getAdElements();
            this.setElementsInView(this.adElements);
            this.startScroll();
        }else{
            this.adElements = this.getAdElements();
            this.adConfigs = this.getAdConfigs(this.adElements);
            this.createSlots(this.adConfigs);   
        }
        

        return this;

    }

    log(message){
        this.isLogEnabled && console.log(message)
    }

    checkLogEnabled(){
        this.isLogEnabled = (location.href.indexOf('adlog=true') > -1) ? true : false;
    }

    setPOSForAll(posAll){
        this.posAll = posAll;
    }


    //for gallery purpose
    enableIdRandomizer(){
        this.randomizeId = true;
    }

    enableRenderOnScroll(){
        this.renderOnScroll = true;
    }

    setElementsInView(elements){

        
        elements.map((el) => {

            //set lazyload attributes first
            el.setAttribute('data-in-view',"false");
            el.setAttribute('data-in-view-rendered',"false");

            //dont lazy load if disable inview is set (render right away)
            (el.hasAttribute("data-disable-inview")) ? this.renderSlotByEl(el) : this.elementsForScroll.push(el);

        });

    }

    startScroll(){

        window.addEventListener('scroll', this.checkSlotsInView.bind(this));
        //also call this for the first time
        this.checkSlotsInView();

    }

    checkSlotsInView(){

        this.elementsForScroll.map((el) => {

            //offset as default first
            var offset = (el.hasAttribute("data-inview-offset")) ? el.dataset.inviewOffset : undefined;

            //if element in view
            if(this.isElementInView(el,offset) && this.isDisplayed(el)){
                //check if in view is false first
                if(el.getAttribute('data-in-view') === "false"){
                    //render slot first time in view
                    if(el.getAttribute("data-in-view-rendered") === "false"){
                        //create slot
                        this.renderSlotByEl(el);
                        el.setAttribute("data-in-view-rendered","true");
                    //refresh in view
                    }else{
                        //dont refresh in view when disable-inview-refresh is added
                        (!el.hasAttribute("data-disable-inview-refresh")) ? this.refresh([el.id]) : undefined;
                    }

                    el.setAttribute('data-in-view',"true");
                }
            //if not in view
            }else{

                if(el.getAttribute('data-in-view') === "true"){
                    el.setAttribute('data-in-view',"false");
                }

            }

        });


    }

    isElementInView(element, offset) {
        //change to when it only shows partial
        var rect = element.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;
        var viewportHeight = window.innerHeight;

        if(offset){
            elemTop -= offset;
            elemBottom += offset;
        }

        var isVisible = elemTop < viewportHeight && elemBottom >= 0;

        return isVisible;
    }

    //https://davidwalsh.name/offsetheight-visibility
    //for parent display check visible
    isDisplayed(element) {

        var displayed = false;

        displayed = (element.offsetHeight !== 0) ? true : false;

        return displayed;

    }

    getVisibleByPct(el) {

        var r = el.getBoundingClientRect(),
        elH = r.height,
        t = r.top, 
        b = r.bottom,
        H = window.innerHeight;

        var visArea = Math.max(0, t > 0 ? Math.min(elH , H - t) : ( b < H ? b : H));

        var pctVisible = (visArea / elH) * 100;

        return pctVisible;

    }

    //AEM getPageMeta. need to have a new one for WP
    getPageMeta(){
        
        var adMeta = {};

        try {
            var meta = document.querySelector('[fs-prop="ads"]');

            adMeta.dfpRootNode = meta.getAttribute("dfp-root-node");
            adMeta.refreshRate = meta.getAttribute("refresh-rate");
            adMeta.networkId = meta.getAttribute("network-id");
            adMeta.pagePath = meta.getAttribute("page-path");
            adMeta.isfwenabled = meta.getAttribute("isfwenabled");
            adMeta.fw_pagepath = meta.getAttribute("fw_pagepath");
            adMeta.pageTargeting = meta.getAttribute("page-targeting");
            adMeta.pageTargeting = JSON.parse(adMeta.pageTargeting);    

        }catch(e){
            console.error("Ads - theres a problem with getting metadata! ", e);
        }
        

        window.fsadmeta = adMeta;

        return adMeta;

    }

    setSiteMeta(pageMeta){

        this.pageMeta = pageMeta;

        this.setTGXSiteConfig(this.pageMeta);

        //adding this back as this is reading from ads meta
        this.setPageRefresh(this.pageMeta.refreshRate);

        return this;
    }

    //TIME library api
    setTGXSiteConfig(pageMeta){

        //remove fscom or fstest in path
        pageMeta.pagePath = pageMeta.pagePath.replace('/fscom/','');
        pageMeta.pagePath = pageMeta.pagePath.replace('/fstest/','');
        pageMeta.pagePath = pageMeta.pagePath.replace('/FSCOM/','');

        //set page targeting
        var pageTargeting = (pageMeta["pageTargeting"]) ? pageMeta.pageTargeting[0] : {};

        var tgxSiteConfig = { // FOR DFP     
            setTargeting: pageTargeting,
            // additional targeting globally on the Slot Level     
            setGlobalTargeting: {
                ch: 'home'
            },
            enableSingleRequest: false,
            collapseEmptyDivs: false,
            //rootnode test
            sitename: pageMeta.dfpRootNode,
            //page path
            zone: pageMeta.pagePath,
            realvu: true, // FSCOM-11830 - Implement RealVu
            //oop: false,
            //debug: true,
            // set debug mode - can also use ?debugads=1     
            //testads: 100
            // use a testads value - can also use ?testads=100 to override 
        }

        console.log("site config ",tgxSiteConfig);

        //time library
        time_dfp.push(function() {
            time_dfp.init(tgxSiteConfig);
        });

    }

    createTGXAdSlot(slotConfig){

        //check if pos is available, not set default value
        slotConfig["pos"] = slotConfig["pos"] || "1";
        //check if pos is forced for all slots
        var pos = (this.posAll) ? this.posAll : slotConfig.pos;       

        var tgxSlot = {         
            id: slotConfig.id,         
            size: slotConfig.slotSizes,
            targeting: {             
                'param': 'value',             
                'pos': pos,
                'location': 'TOP'
            },         
            collapse: true     
        }

        //check if responsive sizes is provided
        if(slotConfig.responsiveSizes && slotConfig.responsiveSizes.length > 0){
            tgxSlot.sizes = slotConfig.responsiveSizes;
        }

        //conditional logging
        this.log("Ads - slot Created for: " + tgxSlot.id + " size: " + tgxSlot.size.toString());
        this.logPerformanceMark("ADS_CREATE: " + tgxSlot.size.toString());

        this.refreshQueue.push(tgxSlot.id);
        time_dfp.push(function(){     
            time_dfp.defineSlot(tgxSlot); 
        });

        

    }

    //can accept array of slots or single slot
    createSlots(configs){

        if(Array.isArray(configs)){
            configs.map((config) => {
                this.createTGXAdSlot(config);
                this.collectionIds.push(config.id);
            }); 
        }else{
            this.createTGXAdSlot(configs);
            this.collectionIds.push(configs.id);
        }       


    }

    getDataConfig(element){

        var data = {};

        if(element && !(element==null)){
             data = JSON.parse(element.getAttribute("data-ad-options"));

             window.lastel = element;
             window.lastdata = data;
        }

        return data;

    }

    getRandomId(){

        var rand = Math.floor(Math.random() * 50);

        return 'fs-ad-rand-' + rand + this.slotCount;

    }

    renderSlotByEl(el){

        var config = this.getConfigFromEl(el);

        this.createSlots(config);

        this.slotCount++;

    }

    getConfigFromEl(el){

        var config = this.getDataConfig(el);

        //process correct id's
        //generate id if theres no id (bigboard pages)
        config["id"] = config.id || this.getRandomId();
        //set this slot as rendered
        el.id = config.id;
        //if randomizer is enabled(only used in gallery)
        if(this.randomizeId){
            config.id = config.id + this.getRandomId();
            el.id = config.id;
        }

        el.setAttribute('data-in-view',"false");
        //el.style.height = "1px";
        el.setAttribute('data-ad-isrendered','true');

        this.slotCount++;

        return config;

    }

    filterAdSelector(){
        //for gallery page filtering
        let desktopOnlySelector = '.fsAdContainer:not(.ad-for-devices):not([data-ad-isrendered])';

        this.adSelector = (window.innerWidth > 1024) ? desktopOnlySelector : this.adSelector;

        return this.adSelector;

    }

    getAdSelector(){

        return this.adSelector;

    }

    getAdElements(){

        var adContainer = this.getAdSelector();

        //check if there is a region for parsing passed
        adContainer = (this.regionEl) ? (this.regionEl+' '+adContainer) : adContainer;

        var allAdElements = [].slice.call(document.querySelectorAll(adContainer));

        //return all ad elements in the page and convert to array
        return allAdElements;

    }

    getAdConfigs(adElements){

        var configs = [];

        [].slice.call(adElements).map((el) => {

            var config = this.getConfigFromEl(el);

            configs.push(config);

        });

        return configs;

    }

    setPageRefresh(refreshRate){

        if (refreshRate > 0) {
            //assign reference to local var for future disposal
            this.refreshTimer = setInterval(function(){
                
                this.refreshAllInView();

            }.bind(this), refreshRate * 1000);

        }

        return this;

    }

    //can accept array of slot ids ["id1","id2"]
    refresh(slotIds){

        var ids = slotIds || undefined;

        //check if slot ids are passed
        if(ids){
            //refresh if its not in refresh queue
            var refreshItems = ids.filter((id) => {
                if(this.refreshQueue.indexOf(id) < 0){
                    //store in the queue
                    this.refreshQueue.push(id);
                    return true;
                }else{
                    return false;
                }   
            });

            this.log("Ads - slot refresh " + refreshItems);

            //only refresh when theres items
            (refreshItems.length > 0) && time_dfp.refresh(refreshItems);

        }else{
            time_dfp.refresh();
        }
        

    }

    //only refresh elements that are in view
    refreshAllInView(){

        this.log("Ads - slot refresh all in view ");

        this.elementsForScroll.map((el) => {

            (this.getVisibleByPct(el) > 50) && this.refresh([el.id]);

        });

    }

    //for gallery external access
    //expects an array of ids
    static refreshSlots(slotIds){

        var ids = slotIds || undefined;

        console.log("Ads - slot external refresh " + ids);

        //check if slot ids are passed
        if(ids){
            time_dfp.refresh(slotIds);
        }else{
            time_dfp.refresh();
        }

    }

    //check first if browser supports perf marks
    logPerformanceMark(message){
        if(window["performance"] && "mark" in performance){
            performance.mark(message);
        }

    }

    
}

export default Ads;


// WEBPACK FOOTER //
// ./assets/components/ads/Ads.js